/*  */
import React, { Component } from 'react'
import { Table, Form, Container, Segment, Button, Header, Icon } from 'semantic-ui-react'
import AddTitleBar from '../titleBar/add_titleBar'
import { withRouter } from 'react-router-dom'
import ReadAxios from '../axiosComponent/readAxios'
import ApproveModal from '../modalComponent/approveModal'
import RejectModal from '../modalComponent/rejectModal'
import BranchModal from '../modalComponent/addBranch'
import VehicleModal from '../modalComponent/addVehicle'
import Axios from 'axios'
import { data } from 'jquery'
import CityNameComponent from './cityNameComponent'
class ApproveRejectForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowItems: [],
            vehicles: [],
            branches: [],
            users: [],
            update: false,
            search_value: props,
            loadingData: true,
            transporterMasterId: [],
            ApproveStatus: "",
            RejectStatus: "",
            status: 'true',
            cityItems: [],
            cityCode: "",
            stateItems: [],
            cityName: [],
            designationItems: [],
            VehicleTypeItems: [],
            branchInfos: [],
            vehicleInfos: [],
            vehicleOpen: false,
            open: false,
            cityNameFetch: []
        }
    }

    componentDidMount(props) {
        // console.log(props, this.state.update)
        this.getData()
        // this.fetchCityName(1)
    }
    getData = () => {
        let current_path = window.location.search
        let id = current_path.substring(1);
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/vendors/`, method: "get", transporterId: id
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    rowItems: res.data.resultSet,
                    vehicles: res.data.resultSet[0]['vehicles'],
                    branches: res.data.resultSet[0]['branches'],
                    users: res.data.resultSet[0]['users'],
                    transporterMasterId: res.data.resultSet[0]['transporterMasterId'],
                    ApproveStatus: res.data.resultSet[0]['isApproved'],
                    RejectStatus: res.data.resultSet[0]['isRejected'],
                    cityCode: res.data.resultSet[0]['companyCity']
                }, () => {
                    this.getCityName(this.state.cityCode)
                }
                )

                { this.state.ApproveStatus == 1 || this.state.RejectStatus == 1 ? this.setState({ status: true }) : this.setState({ status: false }) }
            }
        })

        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/designationMaster`, method: "get",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    designationItems: res.data.resultSet,
                    // isLoaded: true,
                })
            }
        })
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/VehicleTypeMaster`, method: "post",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    VehicleTypeItems: res.data.resultSet,
                    // isLoaded: true,
                })
            }
        })
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/stateMaster`, method: "get",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    stateItems: res.data.resultSet,
                    // isLoaded: true,
                })
            }
        })
    }

    getCityName = (city_code) => {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/cityMaster/${city_code}`, method: "post",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    cityName: res.data.resultSet[0] ? res.data.resultSet[0]["cityName"] : "",
                    // isLoaded: true,
                })
            }
        })
    }

    getDesignationName = (designation_id) => {
        return this.state.designationItems.map((o, i) => {
            const { designationCode, designationId } = o
            if (designationId == designation_id) {
                return (
                    designationCode
                )
            }
        })
    }
    handleBranch = (e, data) => {
        this.setState({
            branchInfos: data.branchInfo,
            open: true
        })
    }
    handleVehicle = (e, data) => {
        this.setState({
            vehicleInfos: data.vehicleInfo,
            vehicleOpen: true
        })
    }
    handleVehicleClose = (e, data) => {
        this.setState({
            vehicleOpen: false
        })
    }
    handleBranchClose = (e, data) => {
        this.setState({
            open: false
        })
    }

    getVehicleTypeName = (vehicleType_id) => {
        return this.state.VehicleTypeItems.map((o, i) => {
            const { vehicleType, vehicleTypeId } = o
            if (vehicleTypeId == vehicleType_id) {
                return (
                    vehicleType
                )
            }
        })
    }

    getStateName = (state_id) => {
        return this.state.stateItems.map((o, i) => {
            const { state, stateId } = o
            if (stateId == state_id) {
                return (
                    state
                )
            }
        })
    }

    renderVendorData() {
        return this.state.rowItems.map((o, i) => {
            const { transporterName, companyAddress, companyCity, companyPincode } = o
            return (
                <React.Fragment>
                    <Form.Group>
                        <Form.Field width={3}>
                            <label><b>Company Name </b></label>
                        </Form.Field>
                        <Form.Field width={4}>
                            <label> {transporterName} </label>
                        </Form.Field>
                        <Form.Field width={1} />
                        <Form.Field width={3}>
                            <label><b>City</b></label>
                        </Form.Field>
                        <Form.Field width={4}>
                            <label> {this.state.cityName} </label>
                        </Form.Field>
                    </Form.Group>
                    <Form.Group>
                        <Form.Field width={3}>
                            <label><b>Address</b></label>
                        </Form.Field>
                        <Form.Field width={4}>
                            <label> {companyAddress} </label>
                        </Form.Field>
                        <Form.Field width={1} />
                        <Form.Field width={3}>
                            <label><b>Pincode</b></label>
                        </Form.Field>
                        <Form.Field width={4}>
                            <label> {companyPincode} </label>
                        </Form.Field>
                    </Form.Group>
                </React.Fragment>


            )
        })
    }

    renderUserData() {
        return this.state.users.map((o, i) => {
            const { realName, email, mobileNo, designation } = o
            return (
                <Table.Row key={i}>
                    <Table.Cell>{realName}</Table.Cell>
                    <Table.Cell>{email}</Table.Cell>
                    <Table.Cell>{mobileNo}</Table.Cell>
                    <Table.Cell>{this.getDesignationName(designation)}</Table.Cell>
                </Table.Row>
            )
        })
    }
    updated = (data) => {
        if (data) {
            this.setState({ update: !this.state.update })
        }
    }

    FetchingBranchData = (data) => {
        console.log('GETVALUSOF BRANCH', data)
    }
    fetchCityName = (city_id) => {
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let gett = localStorage.getItem("apiToken");
        let congData = JSON.stringify
            ({
                customerNo: +customerNo,
                customer_no: +customerNo,
                customerNumber: +customerNo,
                userId: +userId
            })
        let resp = Axios.post(`${process.env.REACT_APP_MAIN_URL}/masters/cityMaster/${+city_id}`, congData, {
            headers: {
                Authorization: `${gett}`,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }
        });
        // return resp.data ? resp.data.resultSet[0].cityName : ''
        resp.then((fetch) => {
            // this.setState({ cityName: fetch.data.resultSet[0].cityName })
            console.log(">>>", fetch.data.resultSet[0].cityName)
        })

    }
    gotCityName = (data) => {
        console.log(data)
    }

    render() {

        if (this.state.rowItems.length === 0) {
            return (
                <>
                    Loading...
                </>
            )
        } else {
            return (
                <div className="w3-card white-bg mt-5 no-margin">
                    <Form >
                        <AddTitleBar className="no-margin" Title="Partner Onboarding Details">
                            <ApproveModal hidden={this.state.status} openBox={this.state.openBranchBox} MasterId={this.state.transporterMasterId} data={this.state.branches} updated={this.props.updated} handleClose={this.handleBranchClose} />
                            <RejectModal hidden={this.state.status} openBox={this.state.openBranchBox} MasterId={this.state.transporterMasterId} data={this.state.branches} updated={this.props.updated} handleClose={this.handleBranchClose} />
                        </AddTitleBar>
                        <br />
                        <Container fluid>
                            <Segment>
                                <div className="ui form tiny">
                                    {this.renderVendorData()}
                                </div>
                            </Segment>
                            <Segment>
                                <div className="ui form tiny">
                                    <Form.Group>
                                        <Form.Field>
                                            <Header size="tiny"><h6>User Details </h6></Header>
                                        </Form.Field>
                                    </Form.Group>
                                    <Table striped>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>Name</Table.HeaderCell>
                                                <Table.HeaderCell>Email</Table.HeaderCell>
                                                <Table.HeaderCell>Phone</Table.HeaderCell>
                                                <Table.HeaderCell>Designation</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {this.renderUserData()}
                                        </Table.Body>
                                    </Table>
                                </div>
                                <br />
                            </Segment>

                            {this.state.branches.length > 0 ?
                                <Segment>
                                    <React.Fragment>
                                        <Form.Group>
                                            <Form.Field>
                                                <Header size="tiny"><h6>Branch Details </h6></Header>
                                            </Form.Field>
                                        </Form.Group>
                                        <Table striped>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Branch</Table.HeaderCell>
                                                    <Table.HeaderCell>State</Table.HeaderCell>
                                                    <Table.HeaderCell>PAN Number</Table.HeaderCell>
                                                    <Table.HeaderCell>GST Number</Table.HeaderCell>
                                                    <Table.HeaderCell>Address</Table.HeaderCell>
                                                    <Table.HeaderCell>City</Table.HeaderCell>
                                                    <Table.HeaderCell>Pincode</Table.HeaderCell>
                                                    <Table.HeaderCell>More Details</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {this.state.branches.map((o, i) => {
                                                    const { vendorBranchName, vendorBranchStateId, vendorBranchPAN, vendorBranchGST, vendorBranchAddress, vendorBranchCity, vendorBranchBranchPincode } = o
                                                    return (
                                                        <Table.Row key={i}>
                                                            <Table.Cell>{vendorBranchName}</Table.Cell>
                                                            <Table.Cell>{this.getStateName(vendorBranchStateId)}</Table.Cell>
                                                            <Table.Cell>{vendorBranchPAN}</Table.Cell>
                                                            <Table.Cell>{vendorBranchGST}</Table.Cell>
                                                            <Table.Cell>{vendorBranchAddress}</Table.Cell>
                                                            <Table.Cell>
                                                                {/* {this.fetchCityName(vendorBranchCity)} */}
                                                                <CityNameComponent
                                                                    cityId={vendorBranchCity}

                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell>{vendorBranchBranchPincode}</Table.Cell>
                                                            <Table.Cell>
                                                                <Button branchInfo={o} onClick={this.handleBranch} icon size="mini" basic><Icon name="eye" color="blue" /></Button>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    )
                                                })}
                                            </Table.Body>
                                        </Table>
                                    </React.Fragment>
                                </Segment>
                                : ""}

                            {this.state.vehicles.length > 0 ?
                                <Segment>
                                    <React.Fragment>
                                        <Form.Group>
                                            <Form.Field>
                                                <Header size="tiny"><h6>Vehicle Details</h6> </Header>
                                            </Form.Field>
                                        </Form.Group>
                                        <Table striped>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Vehicle No.</Table.HeaderCell>
                                                    <Table.HeaderCell>Vehicle Type</Table.HeaderCell>
                                                    <Table.HeaderCell>Dimensions (in FT)</Table.HeaderCell>
                                                    <Table.HeaderCell>Capacity (in MT)</Table.HeaderCell>
                                                    <Table.HeaderCell>GPS Partner</Table.HeaderCell>
                                                    <Table.HeaderCell>Base Location</Table.HeaderCell>
                                                    <Table.HeaderCell>More Details</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {this.state.vehicles.map((o, i) => {
                                                    return (
                                                        <Table.Row key={i}>
                                                            <Table.Cell>{o.vehicleNumber}</Table.Cell>
                                                            <Table.Cell>{this.getVehicleTypeName(o.vehicleTypeId)}</Table.Cell>
                                                            <Table.Cell>{o.vehicleDimensions} </Table.Cell>
                                                            <Table.Cell>{o.vehicleCapacity} </Table.Cell>
                                                            <Table.Cell>{o.vehicleGps}</Table.Cell>
                                                            <Table.Cell>{o.vehicleBaseLocation}</Table.Cell>
                                                            <Table.Cell>
                                                                <Button vehicleInfo={o} onClick={this.handleVehicle} icon size="mini" basic><Icon name="eye" color="blue" /></Button>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    )
                                                })}
                                            </Table.Body>
                                        </Table>
                                    </React.Fragment>
                                </Segment>
                                : ""}
                        </Container>
                    </Form>

                    {this.state.open ? <BranchModal
                        openBox={this.state.openBranchBox}
                        updated={this.props.updated}
                        handleClose={this.handleBranchClose}
                        getbranchdata={this.FetchingBranchData}
                        onClose={this.handleBranchClose}
                        open={this.state.open}
                        branchInfo={this.state.branchInfos}
                        mode="edit"
                    /> : ''}

                    {this.state.vehicleOpen ? <VehicleModal
                        openBox={this.state.vehicleOpen}
                        getvehicledata={this.getVehicleDetials}
                        updated={this.props.updated}
                        handleClose={this.handleVehicleClose}
                        vehicleInfo={this.state.vehicleInfos}
                        mode="edit"
                    /> : ''}
                </div>
            )
        }

    }

}

export default withRouter(ApproveRejectForm);